import { render } from "./KitchenHistory.vue?vue&type=template&id=b2f449ae"
import script from "./KitchenHistory.vue?vue&type=script&lang=js"
export * from "./KitchenHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__